import { Player } from '@loomhq/createhq';
import * as loggerx from 'utilities/loggerx';
import * as analytics from 'utilities/analytics';
import { isFromPublicSharePage, getParam } from 'utilities/url';
import { getAppSource } from 'utilities/device';

interface DurationParams {
  videoId: string;
  player: Player;
  totalDuration: number;
  selectedWorkspaceId?: string;
}

function trackVideoWatchDuration(params: DurationParams): void {
  const { totalDuration, player, videoId, selectedWorkspaceId } = params;
  const { anonID, deviceID } = analytics.getAnalyticsIds();
  const { fromPublicSharePage, parentLocation } = isFromPublicSharePage();
  const sharedAppSource = getParam('sharedAppSource');
  const fromUrl = window.decodeURIComponent(getParam('from_url') || '');

  // protect against overflow errors - we treat someone watching this video over
  // 1000 times in a single session as an anomaly that gets discarded
  if (totalDuration >= player.duration * 1000) {
    loggerx.error('large video watch track duration', {
      totalDuration,
      video_id: videoId,
    });

    return;
  }

  try {
    sendBeaconRequest(
      JSON.stringify({
        anonID,
        deviceID,
        duration: totalDuration,
        speed: player.playbackRate,
        // This need to be updated when we work on embedding the player for the share page
        // embedded_on: isMainVideoOnSharePage ? null : document.referrer,
        // from_link_expand: fromLinkExpand,
        // from_public_share_page: fromPublicSharePage,
        // is_inline_embed_on_loom: isInlineEmbedOnLoom,
        // theater_mode_enabled: theaterModeEnabled,
        embedded_on: document.referrer,
        from_link_expand: false,
        from_public_share_page: fromPublicSharePage,
        is_inline_embed_on_loom: true,
        full_screen_enabled: isVideoInFullScreen(),
        parent_location: parentLocation || fromUrl,
        theater_mode_enabled: false,
        shared_app_source: sharedAppSource,
        organization_id: selectedWorkspaceId,
        appSource: getAppSource(),
      })
    );
  } catch (err) {
    loggerx.error(err, 'error in track video watch duration creator');
  }
}

function sendBeaconRequest(reqBody: string): Promise<void> {
  const url = '/api/a/tvv';

  // we must use XHR here since fetch doesn't support synchronous requests and
  // this creator is called on window unload:
  //
  // https://github.com/github/fetch/issues/248
  if (!navigator.sendBeacon) {
    return sendAsXHR(url, reqBody);
  }

  navigator.sendBeacon(url + '?beacon', reqBody);

  return Promise.resolve();
}

// TODO: add this on the player object
function isVideoInFullScreen() {
  return document.fullscreenEnabled && document.fullscreenElement;
}

function sendAsXHR(url: string, reqBody: string) {
  const xhr = new XMLHttpRequest();

  return new Promise<void>((res, rej) => {
    xhr.open('POST', url + '?xhr', true);

    xhr.onload = () => {
      if (xhr.readyState === 4) {
        if (xhr.status >= 400) {
          rej(
            Error(
              'Oops! Error tracking video watch duration - ' +
                `HTTP response: ${xhr.status}`
            )
          );
        }
      }

      res();
    };

    xhr.onerror = () => {
      rej(
        Error(
          'Oops! Error tracking video watch duration - ' +
            `HTTP response: ${xhr.status}`
        )
      );
    };

    xhr.send(reqBody);
    console.log('sending xhr');
  });
}

export default trackVideoWatchDuration;
